import TimezoneItem from './TimezonItem';
import { setDateTime } from '../common/util';
import type EventEmitter from '../common/eventEmitter';
import type { ITimezoneConfig } from "../../interface/ITimezone";

const UPDATE_TIME = 60 * 1000; // 1분(ms)

class TimezoneContent {
  config: ITimezoneConfig;
  
  currentTime: number;

  serverLocalTimeDiff: number;

  $element?: HTMLElement;

  emitter: EventEmitter;

  timer?: NodeJS.Timeout;

  itemSet = new Set<TimezoneItem>();

  constructor({ config, startTime, serverLocalTimeDiff, emitter }: {
    config: ITimezoneConfig; 
    startTime: number; 
    serverLocalTimeDiff: number;
    emitter: EventEmitter;
  }) {
    this.config = config;
    this.currentTime = startTime;
    this.serverLocalTimeDiff = serverLocalTimeDiff;
    this.emitter = emitter;

    this.init();
  }

  init() {
    this.initDOM();
    this.setItemSet();
    this.render();
    this.addEvent();
  }

  initDOM() {
    this.$element = document.createElement('div');
    this.$element?.classList?.add('ncui-timezone-content');
  }

  render() {
    this.itemSet?.forEach(v => v?.element && this.$element?.append(v.element));
  }

  destroy() {
    if(this.config?.useSyncUpdate) {
      this.clearTimer();
    }
  }

  setItemSet() {
    const { timezoneArr } = this.config || {};
    
    if(Array.isArray(timezoneArr) && timezoneArr?.length) {
      timezoneArr.forEach(data => {
        this.itemSet.add(new TimezoneItem({ 
          data, 
          currentTime: this.currentTime,
          emitter: this.emitter
        }));
      });
    }
  }

  setTimer() {
    return setTimeout(() => {
      this.emitter?.emit('CHANGE_CURRENT_TIME', this.currentTime + UPDATE_TIME);
      this.syncUpdate();
    }, UPDATE_TIME);
  }

  clearTimer() {
    this.timer && clearTimeout(this.timer);
  }

  syncUpdate() {
    if(this.timer) {
      this.clearTimer();
    }
    this.timer = this.setTimer();
  }

  update(currentTime?: number) {
    // 현재 시간으로 업데이트 - 레이어 닫았다 열었을 때, syncupdate사용할 때
    const nowUTC = currentTime ? setDateTime(currentTime) : (setDateTime() + this.serverLocalTimeDiff);
    this.itemSet.forEach(item => item.update(nowUTC));
    this.currentTime = nowUTC;

    // 타입별 공통 사용
    if(this.config?.useSyncUpdate) {
      this.syncUpdate();
    }
  }

  addEvent() {
    this.emitter?.addEvent('CHANGE_CURRENT_TIME', (currentTime: number) => {
      this.update(currentTime);
    });
  }

  get element() {
    return this.$element;
  }
  
}

export default TimezoneContent;